import type { Image, ImageVariant } from '../graphql/v2';

// Sorted in ascending order.
export const imageToSrcSet = (image: Image) => {
  if (!image || !image.srcSet) {
    return [];
  }

  const srcSet = image.srcSet.map((imageVariation: ImageVariant) => ({
    size: `${imageVariation.width}px`,
    srcSet: imageVariation.uri || '',
    variationName: imageVariation.name || `${imageVariation.width}w`,
  }));

  return srcSet;
};
